import { useState } from 'react';
import { motion } from 'framer-motion';

export default function SalesItem({ imageUrl, name, onClick }) {
  const [isHovered, setIsHovered] = useState(false);

  // Configuración de transición spring para suavidad
  const springTransition = { type: 'spring', stiffness: 120, damping: 20 };

  // Unifica la sombra y transición con InfoBlock
  const initialShadow = '1px 4px 7px 2px rgba(0,0,0,0.30)';
  const hoverShadow = '1px 4px 10px 3px rgba(94,94,94,0.70)';
  const shadowTransition = { duration: 0.3, ease: 'easeInOut' };

  return (
    <motion.div
      className="relative w-full h-64 sm:h-72 md:h-80 lg:h-64 xl:h-72 overflow-hidden cursor-pointer rounded-xl"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onTouchStart={() => setIsHovered(true)}
      onTouchEnd={() => setIsHovered(false)}
      onTouchCancel={() => setIsHovered(false)}
      onClick={onClick}
      animate={{
        scale: isHovered ? 1.02 : 1,
        boxShadow: isHovered ? hoverShadow : initialShadow,
      }}
      transition={{
        boxShadow: shadowTransition,
        scale: springTransition,
      }}
    >
      {/* Imagen con zoom y parallax */}
      <motion.img
        src={imageUrl}
        alt={name}
        className="w-full h-full object-cover"
        animate={{ scale: isHovered ? 1.05 : 1, y: isHovered ? -5 : 0 }}
        transition={springTransition}
      />

      {/* Overlay negro suave */}
      <motion.div
        className="absolute inset-0"
        style={{ backgroundColor: 'rgba(0,0,0,0)' }}
        animate={{
          backgroundColor: isHovered ? 'rgba(0,0,0,0.50)' : 'rgba(0,0,0,0)',
        }}
        transition={{ duration: 0.4, ease: 'easeInOut' }}
      />

      {/* Banner inferior frosted glass */}
      <motion.div
        className="absolute bottom-0 left-0 w-full py-3 text-center font-bold font-heading text-white"
        style={{
          backdropFilter: 'blur(6px)',
          backgroundColor: 'rgba(75, 85, 99, 0.8)',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomLeftRadius: '0.75rem',
          borderBottomRightRadius: '0.75rem',
        }}
      >
        <span>{name}</span>
      </motion.div>
    </motion.div>
  );
}
